import * as firebase from "firebase";

export default {
    methods: {
        tl(tlObj) {
            if (tlObj) {
                if (this.$i18n.locale === "np" && "np" in tlObj) {
                    return tlObj.np;
                } else {
                    return tlObj.en;
                }
            }
        },
        openUrlInNewTab(url) {
            window.open(url,"_blank");
        },
        logEvent(eventName, params) {
            if(params) {
                firebase.analytics().logEvent(eventName, params);
            } else {
                firebase.analytics().logEvent(eventName);
            }
        },
        okkharClicked(from) {
            this.logEvent("linkClick", {
              name: "Okkhar.com",
              link: "https://www.okkhar.com",
              from: from
            });
            this.openUrlInNewTab("https://www.okkhar.com");
        },
        gotoRoute(routeName, params=undefined) {
          if (this.$route.name !== routeName) {
            if (params) {
                this.$router.push({ name: routeName, params: params });
            } else {
                this.$router.push({ name: routeName });
            }
          }
          this.$vuetify.goTo(0, 50, 200);
        },
        validEmail: function(email) {
            var re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
            return re.test(email);
        }
    }
}